import { useSwitch, type UseSwitchParameters } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'

import { Radio } from 'base-ui'

type RadioProps = Omit<UseSwitchParameters, 'defaultChecked'> & {
  'aria-label'?: string
  className?: string
  dataQaId?: string
  id: string
  label: string
  name: string
  size?: 'medium' | 'small'
  value?: string
}

export const RadioInput: FC<
  Omit<ComponentProps<'input'>, 'size'> & RadioProps
> = (props) => {
  const {
    className,
    dataQaId,
    id,
    label: labelComp,
    name,
    ref,
    size,
    value,
    ...rest
  } = props
  const { checked, getInputProps, readOnly } = useSwitch(rest)

  return (
    <label
      className={clsx(
        'flex items-start gap-2.5 text-m leading-m text-dark-primary-max',
        className,
      )}
      htmlFor={id === name ? name : id}
    >
      <Radio
        {...getInputProps()}
        checked={checked}
        data-qa-id={dataQaId}
        id={id}
        name={name}
        readOnly={readOnly}
        ref={ref}
        size={size}
        value={value}
      />
      <span>{labelComp}</span>
    </label>
  )
}
